// ===========================================
// ROOT REDIRECT COMPONENT
// ===========================================

import { Navigate } from 'react-router-dom';
import { isAdminDomain } from '@/utils/domain';
import { appConfig } from '@/config';

/**
 * Smart root redirect that sends users to the appropriate entry point.
 * - Admin domain → /admin/login
 * - Public domain → /{savedLang}/home  (clean URL, lang from localStorage)
 */
export function RootRedirect() {
  const isAdmin = isAdminDomain();

  if (isAdmin) {
    return <Navigate to="/admin/login" replace />;
  }

  // Restore the language the user last used, fall back to site default
  const savedLang =
    localStorage.getItem('tt_language') ||
    localStorage.getItem('i18nextLng')?.split('-')[0] ||
    appConfig.defaultLanguage ||
    'en';

  return <Navigate to={`/${savedLang}/home`} replace />;
}
